module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.f4769f9b.eot";